import { createActions } from "redux-actions";

export const {
  getDocumentsFillTypes,
  getDocumentsFillTypesSuccess,
  getDocumentsFillTypesFailure,
  getDocumentsStatuses,
  getDocumentsStatusesSuccess,
  getDocumentsStatusesFailure,
  getDocumentsTypes,
  getDocumentsTypesSuccess,
  getDocumentsTypesFailure,
  getRequestStatuses,
  getRequestStatusesSuccess,
  getRequestStatusesError,
  getOrderStatuses,
  getOrderStatusesSuccess,
  getOrderStatusesError,
  getRequestTypes,
  getRequestTypesSuccess,
  getRequestTypesError,
  getMaintenanceLevels,
  getMaintenanceLevelsSuccess,
  getMaintenanceLevelsError,
  getPaymentMethods,
  getPaymentMethodsSuccess,
  getPaymentMethodsError,
  getServiceTypes,
  getServiceTypesSuccess,
  getServiceTypesError,
  getRegions,
  getRegionsSuccess,
  getRegionsError,
  getWeekDays,
  getWeekDaysSuccess,
  getWeekDaysError,
  getSubjects,
  getSubjectsSuccess,
  getSubjectsError,
  getRoles,
  getRolesSuccess,
  getRolesError,
  getVehicleCategories,
  getVehicleCategoriesSuccess,
  getVehicleCategoriesError,
  getCitizenships,
  getCitizenshipsSuccess,
  getCitizenshipsError,
  getIdentityDocuments,
  getIdentityDocumentsSuccess,
  getIdentityDocumentsError,
  getForeignLanguages,
  getForeignLanguagesSuccess,
  getForeignLanguagesError,
  getProfileStatus,
  getProfileStatusSuccess,
  getProfileStatusError,
  getRequestViews,
  getRequestViewsSuccess,
  getRequestViewsError,
  getServiceAdditionals,
  getServiceAdditionalsSuccess,
  getServiceAdditionalsError,
  getPerformers,
  getPerformersSuccess,
  getPerformersFailure,
  getMonetizationTemplates,
  getMonetizationTemplatesSuccess,
  getMonetizationTemplatesError,
  clearFilters
} = createActions(
  "GET_DOCUMENTS_FILL_TYPES",
  "GET_DOCUMENTS_FILL_TYPES_SUCCESS",
  "GET_DOCUMENTS_FILL_TYPES_FAILURE",
  "GET_DOCUMENTS_STATUSES",
  "GET_DOCUMENTS_STATUSES_SUCCESS",
  "GET_DOCUMENTS_STATUSES_FAILURE",
  "GET_DOCUMENTS_TYPES",
  "GET_DOCUMENTS_TYPES_SUCCESS",
  "GET_DOCUMENTS_TYPES_FAILURE",
  "GET_REQUEST_STATUSES",
  "GET_REQUEST_STATUSES_SUCCESS",
  "GET_REQUEST_STATUSES_ERROR",
  "GET_ORDER_STATUSES",
  "GET_ORDER_STATUSES_SUCCESS",
  "GET_ORDER_STATUSES_ERROR",
  "GET_REQUEST_TYPES",
  "GET_REQUEST_TYPES_SUCCESS",
  "GET_REQUEST_TYPES_ERROR",
  "GET_MAINTENANCE_LEVELS",
  "GET_MAINTENANCE_LEVELS_SUCCESS",
  "GET_MAINTENANCE_LEVELS_ERROR",
  "GET_PAYMENT_METHODS",
  "GET_PAYMENT_METHODS_SUCCESS",
  "GET_PAYMENT_METHODS_ERROR",
  "GET_SERVICE_TYPES",
  "GET_SERVICE_TYPES_SUCCESS",
  "GET_SERVICE_TYPES_ERROR",
  "GET_REGIONS",
  "GET_REGIONS_SUCCESS",
  "GET_REGIONS_ERROR",
  "GET_WEEK_DAYS",
  "GET_WEEK_DAYS_SUCCESS",
  "GET_WEEK_DAYS_ERROR",
  "GET_SUBJECTS",
  "GET_SUBJECTS_SUCCESS",
  "GET_SUBJECTS_ERROR",
  "GET_ROLES",
  "GET_ROLES_SUCCESS",
  "GET_ROLES_ERROR",
  "GET_VEHICLE_CATEGORIES",
  "GET_VEHICLE_CATEGORIES_SUCCESS",
  "GET_VEHICLE_CATEGORIES_ERROR",
  "GET_CITIZENSHIPS",
  "GET_CITIZENSHIPS_SUCCESS",
  "GET_CITIZENSHIPS_ERROR",
  "GET_IDENTITY_DOCUMENTS",
  "GET_IDENTITY_DOCUMENTS_SUCCESS",
  "GET_IDENTITY_DOCUMENTS_ERROR",
  "GET_FOREIGN_LANGUAGES",
  "GET_FOREIGN_LANGUAGES_SUCCESS",
  "GET_FOREIGN_LANGUAGES_ERROR",
  "GET_PROFILE_STATUS",
  "GET_PROFILE_STATUS_SUCCESS",
  "GET_PROFILE_STATUS_ERROR",
  "GET_REQUEST_VIEWS",
  "GET_REQUEST_VIEWS_SUCCESS",
  "GET_REQUEST_VIEWS_ERROR",
  "GET_SERVICE_ADDITIONALS",
  "GET_SERVICE_ADDITIONALS_SUCCESS",
  "GET_SERVICE_ADDITIONALS_ERROR",
  "GET_PERFORMERS",
  "GET_PERFORMERS_SUCCESS",
  "GET_PERFORMERS_FAILURE",
  "GET_MONETIZATION_TEMPLATES",
  "GET_MONETIZATION_TEMPLATES_SUCCESS",
  "GET_MONETIZATION_TEMPLATES_ERROR",
  "CLEAR_FILTERS"
);
